const MANUAL_URL = '/api/manuals/manual-geoescala2026.pdf';

export default function ManualPage() {
  return (
    <div className="min-h-screen bg-[#F9FCFF] text-[#2B3E7B]">
      <header className="sticky top-0 z-10 border-b border-[#DCE6FF] bg-[#F0F4FF]/95 backdrop-blur">
        <div className="mx-auto flex h-[72px] max-w-6xl items-center justify-between px-4 sm:px-6">
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#4468C5]">
              Geoescala
            </p>
            <h1 className="text-lg font-bold text-[#2B3E7B]">Manual do aplicativo de profissionais</h1>
          </div>

          <a
            href={MANUAL_URL}
            target="_blank"
            rel="noreferrer"
            className="rounded-[8px] bg-[#4468C5] px-4 py-2 text-sm font-bold text-white transition hover:bg-[#3758AF]"
          >
            Abrir PDF
          </a>
        </div>
      </header>

      <main className="overflow-x-hidden">
        <section className="relative overflow-hidden bg-[linear-gradient(180deg,#120948_0%,#0C0737_100%)] text-white">
          <div className="absolute inset-0 bg-[linear-gradient(267deg,rgba(2,0,72,0.8)_33.4%,rgba(2,0,72,0.72)_58.9%)]" />
          <div className="relative mx-auto grid max-w-6xl gap-8 px-4 py-12 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:py-16">
            <div className="max-w-2xl">
              <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-[#132C6C] px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.1em] text-white">
                <span className="h-2 w-2 rounded-full bg-white" />
                Aplicativo de profissionais
              </p>
              <h2 className="text-4xl font-bold leading-[0.95] tracking-[-0.04em] text-[#8FAEFF] sm:text-5xl">
                Manual do aplicativo de profissionais
              </h2>
              <p className="mt-5 max-w-xl text-base leading-7 text-white/82 sm:text-lg">
                Acesse o guia completo do app de profissionais com orientações
                de uso, fluxos principais e apoio rápido para o dia a dia.
              </p>
            </div>

            <div className="rounded-[28px] border border-white/10 bg-white/8 p-5 shadow-[0_20px_60px_rgba(8,5,43,0.35)] backdrop-blur-md">
              <div className="rounded-[22px] border border-white/12 bg-[#F9FCFF] p-5 text-[#2B3E7B]">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#4468C5]">
                  Preview
                </p>
                <p className="mt-3 text-sm leading-6 text-[#495764]">
                  Se o documento não carregar no preview, use o botão acima para abrir
                  o PDF em uma nova aba.
                </p>
                <div className="mt-4 flex flex-wrap gap-3">
                  <span className="rounded-full bg-[#EAF1FF] px-3 py-1 text-xs font-semibold text-[#4468C5]">
                    Guia completo
                  </span>
                  <span className="rounded-full bg-[#EEF3FF] px-3 py-1 text-xs font-semibold text-[#4B5C99]">
                    Atualizado 2026
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-10">
          <div className="overflow-hidden rounded-[28px] border border-[#DCE6FF] bg-white shadow-[0_20px_50px_rgba(68,104,197,0.10)]">
            <iframe
              title="Manual Geoescala"
              src={MANUAL_URL}
              className="h-[calc(100vh-10rem)] min-h-[720px] w-full bg-white"
            />
          </div>
        </section>
      </main>
    </div>
  );
}
